import { createApp, reactive } from 'petite-vue';
import { debouncer, documentReady } from "../Utility/utils";
// import {ScrollTrigger} from "gsap/ScrollTrigger";
import {ScrollSmoother} from "gsap/ScrollSmoother";

// gets the URL
const siteURL = document.location.origin;

createApp({
  search() {
    const state = reactive({
      search: "",
      results: [],
      fetchState: "pending",
      category: ""
    });

    const callSearch = (event) => {
      // console.log(event);
      event.preventDefault();
      state.fetchState = "pending";

      const formData = new FormData(event.target);
      
      const url = new URL(siteURL + "/wp-json/wp/v2/posts");
      
      url.searchParams.set('per_page', 10);
      url.searchParams.set('search', formData.get('search'));
      url.searchParams.set('_embed', 'wp:term');
      // url.searchParams.set('before', formData.get('date')+'T23:59:59');
      
      if(formData.get('category')!='-1') {
        url.searchParams.set('categories', formData.get('category'));
      }

      fetch(url)
        .then((res) => {
          return res.json();
        })
        .then((results) => {
          state.results = results;
          state.fetchState = "resolved";
          this.$nextTick().then(function(){
            ScrollSmoother.get().scrollTrigger.refresh(true)
          })
        });
    };

    const formatDate = (date) => {
      const dateObj = new Date(date);
      return new Intl.DateTimeFormat('en-US',{dateStyle:'medium'}).format(dateObj);
    };

    return {
      state,
      formatDate,
      callSearch
    };
  }
}).mount();